import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {CampaignCodeType} from "../../config/Constants";
import React from "react";
import DatePicker from "react-datepicker";
import {addDays, format} from "date-fns";
const campaignCodeTypesArray = Object.values(CampaignCodeType);

const CampaignSchema = Yup.object().shape({
    code: Yup.string().required("Code is required"),
    campaign_name: Yup.string().required("Campaign name is required"),
    type: Yup.string().oneOf(campaignCodeTypesArray).required("Type is required"),
    expiration_date: Yup.date()
        .required("Expiration date is required")
        .min(new Date(), "Expiration date must be in the future"),
    redeem_before_date: Yup.date()
        .required("Redeem date is required")
        .min(new Date(), "Redeem date must be in the future"),
});
const tomorrowPlaceholder = format(addDays(new Date(), 1), "dd-MM-yyyy");
const CampaignCodeForm = ({ initialValues, onSubmit, isEditing = false }) => {
    return (
        <Formik
            initialValues={{
                code: "",
                campaign_name: "",
                type: CampaignCodeType.DISTRIBUTION,
                expiration_date: "",
                redeem_before_date: "",
                ...initialValues,
            }}
            validationSchema={CampaignSchema}
            onSubmit={async (values, actions) => {
                try {
                    await onSubmit(values);
                } catch (error) {
                    console.error(error);
                } finally {
                    actions.setSubmitting(false);
                }
            }}
        >
            {({ setFieldValue , isSubmitting}) => (
                <Form className="card p-4 shadow rounded">
                    <div className="form-group mb-3">
                        <label>Code</label>
                        <Field
                            name="code"
                            type="text"
                            className="form-control"
                            disabled={isEditing}
                        />
                        <ErrorMessage
                            name="code"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Campaign Name</label>
                        <Field name="campaign_name" type="text" className="form-control"/>
                        <ErrorMessage
                            name="campaign_name"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Type</label>
                        <Field name="type" as="select" className="form-control">
                            {campaignCodeTypesArray.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </Field>
                        <ErrorMessage
                            name="type"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Expiration Date</label>
                        <Field name="expiration_date">
                            {({ field, form }) => (
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={field.value ? new Date(field.value) : null}
                                    onChange={(date) => form.setFieldValue(field.name, date)}
                                    placeholderText={tomorrowPlaceholder}
                                    autoComplete="off"
                                />
                            )}
                        </Field>
                        <ErrorMessage
                            name="expiration_date"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Redeem Before Date</label>
                        <Field name="redeem_before_date">
                            {({ field, form }) => (
                                <DatePicker
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={field.value ? new Date(field.value) : null}
                                    onChange={(date) => form.setFieldValue(field.name, date)}
                                    placeholderText={tomorrowPlaceholder}
                                    autoComplete="off"
                                />
                            )}
                        </Field>
                        <ErrorMessage
                            name="redeem_before_date"
                            component="div"
                            className="text-danger"
                        />
                    </div>
                    <div className="text-end toolbar toolbar-bottom p-2">
                        <button className="btn btn-secondary sw-btn-next ms-1" type="submit" disabled={isSubmitting}>
                            {isEditing ? "Update Campaign Code" : "Add Campaign Code"}
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default CampaignCodeForm;